import { createContext } from 'react';

const ExerciseManagerContext = createContext({ showScore: false });

export { ExerciseManagerContext };
